module.exports = __webpack_public_path__ + "static/media/serieST.beb32195.pdf";